<template>
    <div class="flex-fill flex-column no-scroll pa-2" style="height: 400px;">
        <v-simple-table v-if="hasGuardian" dense>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Students</th>
                        <th>Address</th>
                        <th>Phone</th>
                        <th>Work Phone</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ extraStudentInfo.guardian_full_name }}</td>
                        <td>{{ guardianStudents }}</td>
                        <td>{{ guardianAddress }}</td>
                        <td>{{ extraStudentInfo.guardian_phone_number }}</td>
                        <td>{{ extraStudentInfo.guardian_work_phone_number }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <div v-else class="grey--text pa-2">No guardian information available for this student.</div>
    </div>
</template>

<script>
    export default {
        name: 'StudentGuardians',

        computed: {
            hasGuardian() {
                return !!this.extraStudentInfo?.guardian_full_name
            },

            guardianStudents() {
                return (this.extraStudentInfo?.guardian_students || '')
                    .split(';')
                    .map(v => v.trim())
                    .filter(Boolean)
                    .join(', ')
            },

            guardianAddress() {
                let s = this.extraStudentInfo
                if (!s) return ''
                return [
                    s.guardian_addr_street,
                    s.guardian_addr_city,
                    [s.guardian_addr_state, s.guardian_addr_zip].filter(Boolean).join(' ')
                ].filter(Boolean).join(', ')
            }
        },

        props: {
            extraStudentInfo: null,
        },
    }
</script>

<style lang="scss" scoped>
</style>
